<template>
  <div class="min-h-screen flex flex-col items-center justify-center">
    <!-- <h1 class="text-3xl font-bold mb-4">Mobile Not Supported</h1>
    <p>Please use a tablet or desktop to access this application.</p> -->
    <router-link :to="{ name: 'product' }">
      <img alt="Icon" class="mx-auto h-10 w-auto" src="@/assets/img/logo-light.png" />
    </router-link>


    <h1 class="mt-6 text-2xl sm:text-3xl font-bold mb-3">Sitio no compatible con móviles</h1>
    <p class="p-4 text-lg flex justify-center text-center">Usa una computadora o
      tablet para acceder a esta
      aplicación.
    </p>
  </div>
</template>

<script>
export default {
  name: "notSupported"
};
</script>
